import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SearchX } from "lucide-react";
import { SubPage, EmptyState, Spinner } from "../components/common";
import ListingCard from "../components/ListingCard";
import { Avatar } from "./MessagesPage";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { monthYear } from "../lib/format";

export default function UserProfilePage() {
  const { id } = useParams();
  const { t, lang } = useLang();
  const [profile, setProfile] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => { api.get(`/users/${id}/profile`).then((r) => setProfile(r.data)).catch(() => setMissing(true)); }, [id]);

  if (missing) return <SubPage title="" testid="user-profile-page"><EmptyState icon={SearchX} title={t("detail.notFound")} testid="user-profile-missing" /></SubPage>;
  if (!profile) return <SubPage title="" testid="user-profile-page"><div className="flex justify-center py-10"><Spinner /></div></SubPage>;
  return (
    <SubPage title={profile.name} testid="user-profile-page">
      <div className="flex items-center gap-4 rounded-3xl bg-white p-5 shadow-[0_4px_20px_rgba(13,42,107,0.06)]">
        <Avatar user={profile} size="h-20 w-20" />
        <div>
          <h2 className="text-2xl font-extrabold text-navy" data-testid="user-profile-name">{profile.name}</h2>
          <p className="text-sm text-slate-500">{t("detail.memberSince", { date: monthYear(profile.member_since, lang) })}</p>
        </div>
      </div>
      <h3 className="mb-3 mt-6 font-extrabold text-navy">{t("up.listings", { name: profile.name })}</h3>
      {profile.listings.length === 0 ? <p className="text-sm text-slate-500" data-testid="user-profile-no-listings">{t("up.noListings")}</p> : (
        <div className="grid grid-cols-2 gap-x-3 gap-y-5 sm:grid-cols-3 lg:grid-cols-4" data-testid="user-profile-listings">
          {profile.listings.map((l, i) => <ListingCard key={l.id} listing={l} index={i} />)}
        </div>
      )}
    </SubPage>
  );
}
